import React, { Component } from 'react';
import queryString from 'query-string'
import Cookies  from 'universal-cookie';
import  axios  from 'axios';
import { VkGroupBlock } from './VkGroupBlock';
import { WidgetTemplateVk } from './WidgetTemplateVk';
import { RedPageComponent } from './RedPageComponent';
import { HorizontalLine } from './HorizontalLine';
import { LineProgressBar } from '@frogress/line';
import LeftArrowIcon from './LeftArrowIcon';


export class VkCreateWidget extends React.Component {


    //access_token = '3b3725010170af430485b9a6b127d74a649730b3ffd0dcfa76113dc4cb9998592d24272d137a98940654d';
    
    state = {
      showPreview : false,
      widget_name : '',
      channel_name: '@kriptanewsbest',
      showErrorMsg : false,
      errorMsg : null,
      tmp_id : null,
      big_img_src : null,
      small_img_src : null,
      selected_file : null,
      selectedFile : null,
      prize : '',
      header_text : '',
      main_text : '',
      btnText : 'Подписаться',
      socialNetwork : 'tg',
      scriptsText : null,
      timeout: 0,
      stage : '100_vk',
        showProgressNum : false,
        infoBlock: '',
        successMsg : '',
        showSuccessMsg : false,
        stageNum: 4,
        bg_mobile_opacity : 1,
        show_color_picker_bg_mobile_color : false,
        bg_mobile_color : 'white',
        bg_mobile_color_hex: 'white',
        frame_view_type: 'desktop',
        frame_height: 300,
        frame_width : 571,
        bg2_opacity : 1,
        bg2_color_hex: 'black',
        bg1_color_hex: 'yellow',
        bg1_opacity : 1,
        btn_color_hex : 'blue',
        h1_color : 'black',
        h1_color_hex: 'black',
        h2_color_hex: 'black',
        logo_color_hex: 'black',
        btn_text_color_hex: 'white',
        show_color_picker_btn_color : false,
        btn_color : 'blue',
        show_color_picker_bg1_color : false,
        bg1_color : 'blue',
        show_color_picker_bg2_color : false,
        bg2_color : 'blue',
        show_color_picker_btn_text_color : false,
        btn_text_color : 'white',
        show_color_picker_h1_color: false,
        show_color_picker_h2_color : false,
        h2_color : 'black',
        show_color_picker_logo_color : false,
        logo_color : 'green'
    }

    constructor(props) {
        super(props);
        const cookies = new Cookies();
        if (cookies.get('vk_group_id')) {
          this.group_id = cookies.get('vk_group_id')          

        }
        else {
            this.group_id = 1 //ИСПРАВИЛ
            //window.location.href = '/createwidget'
        }
        this.setShowPreview = this.setShowPreview.bind(this)
        this.doSave = this.doSave.bind(this)
        this.updatePrize = this.updatePrize.bind(this)
        this.updateHeader = this.updateHeader.bind(this)
        this.updateMain = this.updateMain.bind(this) 
        this.updateMain = this.updateMain.bind(this)
        this.handleInputChange_smallImg = this.handleInputChange_smallImg.bind(this)
        this.handleInputChange_bigImg = this.handleInputChange_bigImg.bind(this)   
        this.updateTimeout = this.updateTimeout.bind(this)
        this.ClearPhotoMobile = this.ClearPhotoMobile.bind(this)
        this.changeFrameView = this.changeFrameView.bind(this)
        this.showColorPicker = this.showColorPicker.bind(this)
        this.setDefault = this.setDefault.bind(this)
        this.handleClickOutside = this.handleClickOutside.bind(this)
        

        this.colorPickerBgMobileColorRef = React.createRef();
        this.refFirstStage = React.createRef();
        this.colorPickerBtnColorRef = React.createRef();
        this.colorPickerBg1ColorRef = React.createRef();
        this.colorPickerBg2ColorRef = React.createRef();
        this.colorPickerBtnTextColorRef = React.createRef();
        this.colorPickerH1ColorRef = React.createRef();
        this.colorPickerH2ColorRef =  React.createRef();
        this.colorPickerLogoColorRef =  React.createRef();
    
    
    }
     
    setDefault() {
        this.setState({
            bg1_color : {r:7, g:103, b:244, a:0.04},
            bg1_color_hex: '#0767F4',
            bg1_opacity : 0.04,
            

            bg2_color : {r: 255, g: 255, b:255, a:1},
            bg2_color_hex: 'white',
            bg2_opacity : 1,
            

            bg_mobile_color : {r: 255, g: 255, b:255, a:1},
            bg_mobile_color_hex: 'white',
            bg_mobile_opacity : 1,

            btn_text_color : {r: 255, g: 255, b:255, a:1},
            btn_text_color_hex: 'white',
             

            btn_color : {r:7, g:103, b:244, a:0.04},
            btn_color_hex: '#0767F4',

            h1_color : {r: 0, g: 0, b:0},
            h1_color_hex: '#000000',
             

            h2_color : {r: 137, g: 137, b:137 , a:1},
            h2_color_hex: '#898989',
             

            logo_color : {r:7, g:103, b:244, a:0.04},
            logo_color_hex: '#0767F4',
        })
          
    }
    
    initialContent = () => {
        //286 571

        return (
          `<!DOCTYPE html>
          <html>
            <head>
              <link href="https://storage.yandexcloud.net/clientsaverstatic/main_with_viewport_v2.css" rel="stylesheet" />
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
            </head>
            <body>
              <div id="page" class="page"></div>
            </body>
          </html>`
        )
      }

    showColorPicker = ( a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        
         
        if (a == 'btn') {
            this.setState({show_color_picker_btn_color: true})
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg1_color: true })
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_bg2_color: true })
        }
        
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_btn_text_color: true })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h1_color: true })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_h2_color: true })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ show_color_picker_logo_color: true })
        }
        if (a == 'bgMobile') {
            
            this.setState({ show_color_picker_bg_mobile_color: true })
        }
       
      }

    getIframeSize(a) {
        
        if (window.screen.width >= 3500) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [788, 1500]
            }
        }

        if (window.screen.width >= 3000) {
            if (a == 'mobile') {
                return [1100, 618]
            }
            else {
                return [688, 1300]
            }
        }

        if (window.screen.width >= 2500) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [618, 1100]
            }
        }


        if (window.screen.width >= 2200) {
            if (a == 'mobile') {
                return [900, 518]
            }
            else {
                return [518, 900]
            }
        }


        if (window.screen.width >= 1750) {
            if (a == 'mobile') {
                return [700, 398]
            }
            else {
                return [398, 700]
            }
        }

        if (window.screen.width >= 1245) {
            if (a == 'mobile') {
                return [571, 300]
            }
            else {
                return [300, 571]
            }
        }

        if (window.screen.width >= 1000) {
            if (a == 'mobile') {
                return [500, 300]
            }
            else {
                return [200, 360]
            }
        }
        if (a == 'mobile') {
            return [500, 300]
        }
        else {
            return [200, 360]
        }

      }

      changeFrameView(a) {
        var d = this.getIframeSize(a)
        
        this.setState({
            frame_view_type : a,
            frame_height: d[0],
            frame_width: d[1]
        })
      }
      rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
      }
      

    handleClickOutside(event) {
        if (this.colorPickerBtnColorRef && !this.colorPickerBtnColorRef.current.contains(event.target)) {
         
            this.setState({
            show_color_picker_btn_color: false
           })
        }
        if (this.colorPickerBg1ColorRef && !this.colorPickerBg1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg1_color: false
           })
        }
        if (this.colorPickerBg2ColorRef && !this.colorPickerBg2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg2_color: false
           })
        }
        
        
        if (this.colorPickerBtnTextColorRef && !this.colorPickerBtnTextColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_btn_text_color: false
           })
        }

        if (this.colorPickerH1ColorRef && !this.colorPickerH1ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h1_color: false
           })
        }
        if (this.colorPickerH2ColorRef && !this.colorPickerH2ColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_h2_color: false
           })
        }

        if (this.colorPickerLogoColorRef && !this.colorPickerLogoColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_logo_color: false
           })
        }

        if (this.colorPickerBgMobileColorRef && !this.colorPickerBgMobileColorRef.current.contains(event.target)) {
         
            this.setState({
                show_color_picker_bg_mobile_color: false
           })
        }
      }
    componentWillMount() {
        this.setDefault()
        this.changeFrameView('desktop')
        document.addEventListener("mousedown", this.handleClickOutside);
        
        
        
        
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleChangeComplete = (color, a) => {
        
        //const decimalToHex = (alpha: number) => alpha === 0 ? '00' : Math.round(255 * alpha).toString(16)

        //const hexCode = `${color.hex}${decimalToHex(color.rgb.a)}` 
        var hexCode = color.rgb
         
        if (a == 'btn') {
            this.setState({ btn_color: hexCode, btn_color_hex:color.hex })
        }
        if (a == 'bg1') {
            //alert(color.rgb.a)
            this.setState({ bg1_color: hexCode, bg1_color_hex: color.hex, bg1_opacity:color.rgb.a})
        }
        if (a == 'bg2') {
            //alert(color.rgb.a)
            this.setState({ bg2_color: hexCode, bg2_color_hex: color.hex, bg2_opacity:color.rgb.a})
        }
        if (a == 'btnText') {
            //alert(color.rgb.a)
            this.setState({ btn_text_color: hexCode, btn_text_color_hex: color.hex })
        }
        if (a == 'h1') {
            //alert(color.rgb.a)
            this.setState({ h1_color: hexCode, h1_color_hex: color.hex })
        }
        if (a == 'h2') {
            //alert(color.rgb.a)
            this.setState({ h2_color: hexCode, h2_color_hex: color.hex })
        }
        if (a == 'logo') {
            //alert(color.rgb.a)
            this.setState({ logo_color: hexCode, logo_color_hex: color.hex })
        }
        if (a == 'bgMobile') {
            //alert(color.rgb.a)
            this.setState({ 
                bg_mobile_opacity: color.rgb.a,
                bg_mobile_color: hexCode, 
                bg_mobile_color_hex: color.hex })
        }
       
      }
      ClearPhotoMobile(e) {
        this.setState((prevState) => {
            return  {
                   ...prevState,
                   small_img_src : null,
                   selectedFile : null
               
               };
       }, () =>  {
           
       })
    }
      updateTimeout(e) {

        this.setState((prevState) => {
            return  {
                   ...prevState,
                   timeout : e.target.value
                   
               
               };
       }, () =>  {
           
       })


    }
      //alert('doSave = 13143');
      doSave(e) {
        e.preventDefault()
        //alert('CheckIntegration')
        const cookies = new Cookies();
        //alert('do save')
        //alert( process.env.REACT_APP_BACKEND_SERVER+'/CreatePage/' )
        


        
        var arr = this.state
        arr.widget_name = cookies.get('widgetNameVk') 
        
        console.log(JSON.stringify( arr ))
        
        axios
            .post(process.env.REACT_APP_BACKEND_SERVER+'/CreateVkWidget/', {
                
                'data' : JSON.stringify( arr ),
                'group_id' : cookies.get('vk_group_id')
                
            }, {
                headers : {
                    'Authorization': 'Bearer '+cookies.get('tgsubs_token')
                }
            } )
            .then(res => {
                
                if (res.data.status == 'ok') {
                    var head_code = '' + 
                    '<script src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.0/jquery.min.js"></script>' + 
                    '	<script>' + 
                    '	$(document).ready(function() {' + 
                    '	if ($(\'meta[name="viewport"]\').length > 0) {' + 
                    '	var html = \'<iframe onload="this.style.visibility=\\\'visible\\\'"; src=\\\''+res.data.link2 +'\\\' style=\\"visibility:hidden; position: fixed; z-index: 1000000000000000000; left: 0; top: 0; height: 100%; width: 100%;\\"></iframe>\';' + 
                    '	$(\'body\').prepend(html)' + 
                    '	}' + 
                    '	else {' + 
                    '	var html = \'<iframe onload="this.style.visibility=\\\'visible\\\'"; src=\\\''+res.data.link1 +'\\\' style="visibility:hidden; position: fixed; z-index: 1000000000000000000; left: 0; top: 0; height: 100%; width: 100%;"></iframe>\';' + 
                    '	$(\'body\').prepend(html)' + 
                    '	}' + 
                    '	}' + 
                    '	)' + 
                    '	</script>' + 
                    '';
                    
                    window.location.href = '/vkwidgetimplementation/'+res.data.alias   
                }
            })
            .catch(err => {
            console.log(err);
            })

          
    }
    


    setShowPreview(e, val) {
      e.preventDefault()
      //alert(1)
      this.setState((prevState) => {
          return  {
                 ...prevState,
                 showPreview : val
                 
             
             };
     }, () =>  {
         
     })
  }

  updatePrize(e) {
    const updatedInputValue = e.target.value;
    
    
    this.setState((prevState) => {
         return  {
                ...prevState,
                prize : updatedInputValue,
                
            
            };
    }, () =>  {
        
    })


}

updateHeader (e) {
    const updatedInputValue = e.target.value;
    
    
    this.setState((prevState) => {
         return  {
                ...prevState,
                header_text : updatedInputValue,
                
            
            };
    }, () =>  {
        
    })
}

updateMain(e) {
    const updatedInputValue = e.target.value;
    
    
    this.setState((prevState) => {
         return  {
                ...prevState,
                main_text : updatedInputValue,
                
            
            };
    }, () =>  {
        
    })
}



handleInputChange_bigImg(event) {
        
  this.setState({
      selectedFile: event.target.files[0],
    }, () => {
      const data = new FormData() 
      data.append('file', this.state.selectedFile)
      console.warn(this.state.selectedFile);
      
      const cookies = new Cookies();
      
      axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
           data, {
              headers: {
                  'Authorization': 'Bearer '+cookies.get('tgsubs_token')
              } // receive two parameter endpoint url ,form data 
      })
      .then(res => { // then print response status
           
          this.setState({
              big_img_src: res.data.link
            }, () => {})
      })
    })

}



handleInputChange_smallImg(event) {
  
  this.setState({
      selectedFile: event.target.files[0],
    }, () => {
      const data = new FormData() 
      data.append('file', this.state.selectedFile)
      console.warn(this.state.selectedFile);
      
      const cookies = new Cookies();
      axios.post(process.env.REACT_APP_BACKEND_SERVER + '/UploadImg/',
           data, {
              headers: {
                  'Authorization': 'Bearer '+cookies.get('tgsubs_token')
              }     // receive two parameter endpoint url ,form data 
      })
      .then(res => { // then print response status
           
          this.setState({
              small_img_src: res.data.link
            }, () => {})
      })
    })

}


    render() {
        return (
          <div className='createPage'>
          <div className="createPageTitle">
              <h1 style={{marginBottom:"2px"}}> { this.props.title ? this.props.title : "Создать чат-бот+виджет"}</h1>
              <HorizontalLine />
          </div>
          <div className='createWidgetMainBlock'>
              <div className="createWidgetMainBlock__progressBar">
                  <div className="createWidgetMainBlock__progressBar_label">
                      Этап:
                  </div>
                  
              <LineProgressBar
                  transition={{ easing: 'linear' }}
                  label={(value) => <div>  <span className={this.state.showProgressNum ? "progressBar_etaps" : "progressBar_etaps hidden"}><span className='progressBar_etaps_blue'>{value * this.state.stageNum / 100}</span>   /   {this.state.stageNum} </span> </div>} 
                  percent={parseInt(this.state.stage.split('_')[0])}
                  rounded={36}
                  height={'2.4em'}
                  progressColor="linear-gradient(90deg, #31D0E1 3.43%, #0868F5 86.29%);"
                  containerColor="#FFF" />`
              </div>
              
          <div onClick={ () => {
              const cookies = new Cookies()
              window.location.href = '/callback?code='+cookies.get('vk_code')
          }} className="createWidgetMainBlock_back">< LeftArrowIcon /> Назад</div> 


            
        
                
                
               
            </div>       

            <div style={{'marginTop': '14em'}}>
            <RedPageComponent
                bg_mobile_opacity={this.state.bg_mobile_opacity} 
                colorPickerBgMobileColorRef={this.colorPickerBgMobileColorRef}                
                show_color_picker_bg_mobile_color={this.state.show_color_picker_bg_mobile_color}
                bg_mobile_color={this.state.bg_mobile_color}
                bg_mobile_color_hex={this.state.bg_mobile_color_hex}
                frame_view_type={this.state.frame_view_type}
                changeFrameView={this.changeFrameView}
                frame_height={this.state.frame_height}
                frame_width={this.state.frame_width}
                showColorPicker={this.showColorPicker}
                bg2_opacity={this.state.bg2_opacity} 
                initialContent={this.initialContent}
                bg2_color_hex={this.state.bg2_color_hex}
                bg1_color_hex={this.state.bg1_color_hex}
                bg1_opacity={this.state.bg1_opacity}
                btn_color_hex={this.state.btn_color_hex}
                refFirstStage={this.refFirstStage}
                h1_color_hex={this.state.h1_color_hex}
                h1_color={this.state.h1_color}
                h2_color_hex={this.state.h2_color_hex}
                logo_color_hex={this.state.logo_color_hex}
                btn_text_color_hex={this.state.btn_text_color_hex}
                setDefault={this.setDefault}
                colorPickerBtnColorRef={this.colorPickerBtnColorRef}
                show_color_picker_btn_color={this.state.show_color_picker_btn_color}
                btn_color={this.state.btn_color}
                handleChangeComplete={this.handleChangeComplete}
                colorPickerBg1ColorRef={this.colorPickerBg1ColorRef}
                show_color_picker_bg1_color={this.state.show_color_picker_bg1_color}
                bg1_color={this.state.bg1_color}
                colorPickerBg2ColorRef={this.colorPickerBg2ColorRef}
                show_color_picker_bg2_color={this.state.show_color_picker_bg2_color}
                bg2_color={this.state.bg2_color}
                colorPickerBtnTextColorRef={this.colorPickerBtnTextColorRef}
                show_color_picker_btn_text_color = {this.state.show_color_picker_btn_text_color}
                btn_text_color={this.state.btn_text_color}
                colorPickerH1ColorRef={this.colorPickerH1ColorRef}
                show_color_picker_h1_color={this.state.show_color_picker_h1_color}
                colorPickerH2ColorRef={this.colorPickerH2ColorRef}
                show_color_picker_h2_color={this.state.show_color_picker_h2_color}
                h2_color={this.state.h2_color}
                colorPickerLogoColorRef={this.colorPickerLogoColorRef}
                show_color_picker_logo_color={this.state.show_color_picker_logo_color}
                logo_color={this.state.logo_color}





                
                ClearPhotoMobile={this.ClearPhotoMobile}
                timeout={this.state.timeout}
                updateTimeout={this.updateTimeout}
                setShowPreview={this.setShowPreview}
                    doSave={this.doSave}
                    big_img_src={this.state.big_img_src}
                small_img_src={this.state.small_img_src}
                selected_file={this.state.selected_file}
                prize={this.state.prize}
                header_text={this.state.header_text}
                main_text={this.state.main_text}
                btnText={this.state.btnText}
                updateMain={this.updateMain}
                updateHeader={this.updateHeader}
                updatePrize={this.updatePrize}
                handleInputChange_bigImg={this.handleInputChange_bigImg}
                handleInputChange_smallImg={this.handleInputChange_smallImg}
                    />    
            </div>           
        </div>         
        )
    }
}